import { IGatsbyImageData } from "gatsby-plugin-image"

import { ArrayElement } from "./type"

const normalizeText = (content: string) => {
  content = content.replaceAll("<strong>", "")
  content = content.replaceAll("</strong>", "")
  content = content.replaceAll("\n", "")
  content = content.replaceAll("<br>", "")
  content = content.replaceAll("</br>", "")
  return content
}

export const htmlText = (content: string) => {
  return content.replaceAll(/\n/g, "<br />")
}

export const getArticleDescription = (articlePartial: {
  description: string | null // 基本使用しない
  descriptionLong: { descriptionLong: string | null } | null
}): string => {
  if (articlePartial.descriptionLong && articlePartial.descriptionLong.descriptionLong) {
    return articlePartial.descriptionLong.descriptionLong
  }
  if (articlePartial.description) {
    return articlePartial.description
  }
  return ""
}

export const ogDescription = (article: any) => {
  if (article.ogDescription) {
    return article.ogDescription
  }
  if (article.talks) {
    let contents = []
    for (let i = 0; i < article.talks.length; i++) {
      const talk = article.talks[i]
      if (!talk.contentText || !talk.contentText.contentText) {
        continue
      }
      const text = talk.contentText.contentText
      contents.push(normalizeText(text))
      if (contents.length === 2) {
        break
      }
    }
    if (contents.length === 0) {
      return getArticleDescription(article)
    }
    return contents.join("")
  }
  if (
    article.firstTalk &&
    article.firstTalk.contentText &&
    article.firstTalk.contentText.contentText
  ) {
    return normalizeText(article.firstTalk.contentText.contentText)
  }
  return getArticleDescription(article)
}

export const isTalkNoText = (talk: any) => {
  if (!talk.contentText) {
    return true
  }
  return false
}

export const isTalkContributorLeft = (talk: any) => {
  if (isTalkNoText(talk)) {
    return false
  }
  // NOTE データ不整合
  if (!talk.contributor) {
    return false
  }
  return talk.contributor.name !== "ペアケア"
}

export const isTalkContributorRight = (talk: any) => {
  if (isTalkNoText(talk)) {
    return false
  }
  // NOTE データ不整合
  if (!talk.contributor) {
    return false
  }
  return talk.contributor.name === "ペアケア"
}

export const isTalksContinuous = (talks: any, idx: number) => {
  const befTalk = talks[idx - 1]
  const curTalk = talks[idx]
  if (!befTalk || isTalkNoText(befTalk) || isTalkNoText(curTalk)) {
    return false
  }
  // NOTE データ不整合
  if (!befTalk.contributor || !curTalk.contributor) {
    return false
  }
  return befTalk.contributor.name === curTalk.contributor.name
}

export const headingSummary = "まとめ"

export const talksHeadings = (article: any) => {
  let headings = []
  if (article.talks) {
    for (let i = 0; i < article.talks.length; i++) {
      const talk = article.talks[i]
      if (!talk.heading) {
        continue
      }
      headings.push(talk.heading)
    }
  }
  if (headings.length !== 0 && article.summary) {
    headings.push(headingSummary)
  }
  return headings
}

export const sectionsHeadings = (article: any) => {
  let headings = []
  for (let i = 0; i < article.sections.length; i++) {
    const section = article.sections[i]
    if (!section.title) {
      continue
    }
    headings.push(section.title)
  }
  if (headings.length !== 0 && article.summary) {
    headings.push(headingSummary)
  }
  return headings
}

export const authorDescription = (contributor: any) => {
  if (contributor.careerHistory && contributor.careerHistory.careerHistory) {
    return contributor.careerHistory.careerHistory
  }
  if (contributor.description) {
    return contributor.description
  }
  if (contributor.company) {
    return contributor.company
  }
  return ""
}

export const authorJobType = (contributor: any) => {
  if (
    [
      "産婦人科医",
      "院長",
      "院長 産婦人科医",
      "産婦人科専門医 周産期（母体・胎児）専門医",
      "理事長・院長",
    ].includes(contributor.job)
  ) {
    return "監修医師"
  }
  if (["管理栄養士"].includes(contributor.job)) {
    return "監修栄養士"
  }
  return "監修者"
}

export const calcMainTextLenConversation = (article: ArrayElement<Queries.CreateDetailConversationQuery["allContentfulArticle"]["nodes"]>) => {
  let len = 0
  article.talks?.forEach(talk => {
    const text = talk?.contentText?.contentText
    if (text) {
      len += [...text].length
    }
    const html = talk?.contentRawHtml?.contentRawHtml
    if (html) {
      len += [...html].length
    }
  })
  const summary = article.summary?.summary
  if (summary) {
    len += [...summary].length
  }
  return len
}

export const calcMainTextLenReport = (article: ArrayElement<Queries.CreateDetailReportQuery["allContentfulArticleReport"]["nodes"]>) => {
  let len = 0
  article.sections?.forEach(section => {
    const title = section?.title
    if (title) {
      len += [...title].length
    }
    section?.contents?.forEach(c => {
      const contentText = c?.contentText?.contentText
      if (contentText) {
        len += [...contentText].length
      }
    })
  })
  const summary = article.summary?.summary
  if (summary) {
    len += [...summary].length
  }
  return len
}